module.exports = __webpack_public_path__ + "static/img/footer-police-beian.d0289dc0.jpg";